module.exports = __webpack_public_path__ + "fonts/Nunito-Italic.80150d0.ttf";